/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.patients

import studio.oddpods.cauce.core.ui.UiText

data class PatientFormState(
    val name: String = "",
    val phone: String = "",
    val email: String = "",
    val defaultFeeInput: String = "",
    val notes: String = "",
    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val error: UiText? = null,
)

sealed class PatientFormAction {
    data class NameChanged(val name: String) : PatientFormAction()
    data class PhoneChanged(val phone: String) : PatientFormAction()
    data class EmailChanged(val email: String) : PatientFormAction()
    data class FeeChanged(val fee: String) : PatientFormAction()
    data class NotesChanged(val notes: String) : PatientFormAction()
    data object SaveClicked : PatientFormAction()
}
